import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { PasswordInput } from 'components/sto';

class PasswordConfirmation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            passwordConfirmation: '',
            passwordConfirmationStateValid: null,
            passwordStateValid: null,
        };
    }

    handleInputChange = (event) => {
        const fieldName = event.target.name;
        const { value } = event.target;
        const { isValid } = event.target;
        let valueState = null;
        const state = `${fieldName}StateValid`;
        switch (fieldName) {
            case 'passwordConfirmation':
                valueState = isValid && value === this.state.password ? true : false;
                break;
            case 'password':
                valueState = isValid;
                break;
            default:
                break;
        }
        this.setState(
            {
                [fieldName]: value,
                [state]: valueState,
            },
            () => {
                this.props.onChange({
                    passwordState: this.state.passwordConfirmationStateValid,
                    passwordValue: this.state.password,
                });
            }
        );
    };

    render() {
        return (
            <div>
                <PasswordInput
                    displayHelper
                    errorMessage="pages.registration.step2.password.field.error"
                    isValid={this.state.passwordStateValid}
                    label={this.props.newLabel || 'pages.registration.step2.password.field'}
                    name="password"
                    onChange={this.handleInputChange}
                    placeholder={this.props.newPlaceHolder || 'pages.registration.step2.password.placeHolder'}
                    value={this.state.password}
                />
                <PasswordInput
                    errorMessage="pages.registration.step2.passwordConfirmation.field.error"
                    isValid={this.state.passwordConfirmationStateValid}
                    label={this.props.confirmLabel || 'pages.registration.step2.passwordConfirmation.field'}
                    name="passwordConfirmation"
                    onChange={this.handleInputChange}
                    placeholder={
                        this.props.confirmPlaceHolder || 'pages.registration.step2.passwordConfirmation.placeHolder'
                    }
                    value={this.state.passwordConfirmation}
                />
            </div>
        );
    }
}

PasswordConfirmation.propTypes = {
    confirmLabel: PropTypes.string,
    confirmPlaceHolder: PropTypes.string,
    newLabel: PropTypes.string,
    newPlaceHolder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    password: PropTypes.object.isRequired,
};

export default injectIntl(PasswordConfirmation);
